<template>
  <div>
    <v-row dense>
      <v-col sm="2" xl="2" md="2" lg="2" class=" flex-justify-end flex-center">
        选择内部稽查模块：
      </v-col>
      <v-col sm="8" xl="8" md="8" lg="8">
        <form-item
          v-model="info.saveAuditFunction"
          class=" flex-0 flex-shrink-0"
          :options="[{text:'旧稽查',value:'1'},{text:'新稽查',value:'2'}]"
          style="width: 250px"
          dense
          type="radio"
          @input="$forceUpdate()"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="2" xl="2" md="2" lg="2" />
      <v-col sm="8" xl="8" md="8" lg="8">
        <v-btn small color="primary" depressed min-width="120" class="mr-2" height="30" style="padding:0 8px" @click="saveProgressLimit">保存</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      initInfo: {
        saveAuditFunction: ''
      },
      info: {
        saveAuditFunction: ''
      }
    }
  },
  mounted() {
    this.getDispatchLimit()
  },
  methods: {
    // 获取
    getDispatchLimit() {
      this.$http.get(this.$api.settingGetAuditFunction, { data: {}, type: 'application/x-www-form-urlencoded' }).then(res => {
        this.initInfo.saveAuditFunction = res.result || ''
        this.info.saveAuditFunction = res.result || ''
      }).catch(() => {
        this.info = {}
      })
    },
    // 确认保存
    saveProgressLimit() {
      this.btnLoading = true
      this.$http.post(this.$api.settingSaveAuditFunction, { data: { ...this.info }, type: 'application/x-www-form-urlencoded' }).then(res => {
        this.$message.success(res.result || res.message)
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
        this.info = this.$deepClone(this.initInfo)
      })
    }
  }
}
</script>

<style>

</style>
